/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import { extend } from "umi-request"
import { goLogin } from "../utils"
import { Toast } from "antd-mobile"
import {
  API_PRE_FIX,
  OFF_LINE,
  SUCC_CODE,
  REQUEST_TOAST_DURATION,
  ERROR_CODE,
  COMMON,
  USER_UNLOGIN,
} from "../const"
import { checkNoToastUrl, checkNoErrorToastUrl } from "./utils"

/**
 * 异常处理程序
 */
const errorHandler = (error: any) => {
  const { response } = error
  console.warn("错误:", error)
  if (response && response.status) {
    const { status } = response
    // const errorText = codeMessage[status] || response.statusText;
    if (status === 401) {
      // 重定向到浑天d
      console.log("重定向")
      goLogin()
      // Toast.fail({
      //   message: `请求错误`,
      //   description: `${status}：${errorText}`,
      // });
      return
    }
  } else if (!response) {
    Toast.hide()
    // Toast.fail({
    //   description: '您的网络发生异常，无法连接服务器',
    //   message: '网络异常',
    // });
  }
  return response
}

const request = extend({
  prefix: API_PRE_FIX,
  timeout: 5000,
  errorHandler, // 默认错误处理
  // credentials: "include", // 默认请求是否带上cookie
  credentials: "include",
  // headers: {
  //   "Content-Type": "application/json;charset=UTF-8"
  // },
  // requestType: 'form',
})

const TIMEOUT = 3000 //小于600MS不提示loading
const timers: any = {} //保存Timer
const host = `${window?.location?.protocol}//${window?.location?.host}`

request.interceptors.request.use((url, options?: any) => {
  //不展示toast的URL 添加到 NO_TOAST_API 数组中
  const noToast = checkNoToastUrl(url?.replace(API_PRE_FIX, ""))
  const ErrorToast = checkNoErrorToastUrl(url?.replace(API_PRE_FIX, ""))
  const index = url?.indexOf("?")
  const path = url?.slice(0, index === -1 ? url?.length : index)
  const PATH = `${host}${path}`

  if (noToast) {
    clearTimeout(timers[PATH])
    timers[PATH] = setTimeout(() => {
      Toast.loading("加载中...", 5)
    }, TIMEOUT)
  }

  options.noToast = noToast
  options.ErrorToast = ErrorToast
  return {
    url,
    options,
  }
})

request.interceptors.response.use((response: any, options: any) => {
  response
    .clone()
    .json()
    .then((data: any) => {
      const index = response?.url?.indexOf("?")
      const PATH = response?.url?.slice(
        0,
        index === -1 ? response?.url?.length : index,
      )

      const { code, message, path } = data

      const { method, noToast, ErrorToast } = options
      if (noToast) {
        Toast.hide()
      }
      clearTimeout(timers[PATH])
      delete timers[PATH]
      //以response message的内容来判断是否登录
      if (code === ERROR_CODE && message?.includes(OFF_LINE)) {
        console.warn("未登录, 即将跳转...", data)
        goLogin()
        return response
      }
      if (code !== SUCC_CODE && message) {
        if (!(path === COMMON.loginApp && message === USER_UNLOGIN)) {
          ErrorToast && Toast.fail(message, REQUEST_TOAST_DURATION)
        }
      } else if (noToast) {
        switch (method?.toLowerCase()) {
          case "post":
            Toast.success("操作成功", REQUEST_TOAST_DURATION)
            break
          case "put":
            Toast.success("修改成功", REQUEST_TOAST_DURATION)
            break
          case "delete":
            Toast.success("删除成功", REQUEST_TOAST_DURATION)
            break
          default:
        }
      }
    })
  return response
})
export default request
